/* eslint-disable */
/**
 * Planned vs Adhoc split for the Batch Performance picker.
 *
 * Batches raised against a production plan are named plainly; batches created
 * outside a plan get a generated name that starts with '#'. That leading '#' is
 * the only signal available on the batch list payload, so it is what we test.
 * Purely a front-end filter — the batch list API is unchanged.
 */

export const BATCH_SOURCE_TABS = [
	{ id: 'planned', label: 'Planned' },
	{ id: 'adhoc', label: 'Adhoc' },
	{ id: 'combined', label: 'All' },
];

export const DEFAULT_BATCH_SOURCE = 'planned';

export const isAdhocBatch = (batch) => String(batch?.batchName ?? '').trimStart().startsWith('#');

export const filterBatchesBySource = (batches, source) => {
	if (!Array.isArray(batches)) return [];
	if (source === 'planned') return batches.filter((b) => !isAdhocBatch(b));
	if (source === 'adhoc') return batches.filter(isAdhocBatch);
	return batches;
};
